import React, { FC } from 'react';
import Select, { SingleValue } from 'react-select';

// Interfaces
import { InputSelectOption } from '../interfaces/Input';

// Components
import { ErrorMessage } from './ErrorMessage';

interface Props {
  label?: string;
  value: string;
  choices: InputSelectOption[];
  onChange: (value: string | undefined) => void;
  placeholder?: string;
  errorMessage?: string;
  className?: string;
  wrapperClassName?: string;
}

const FormikDropdown: FC<Props> = ({
  value,
  label,
  placeholder,
  errorMessage,
  className,
  wrapperClassName,
  choices = [],
  onChange,
}) => {
  className = `aea-form-dropdown ${className || ''}`;

  const handleChange = (newValue: SingleValue<InputSelectOption>) => {
    onChange(newValue?.value as string);
  };
  const getValue = () => {
    if (value) {
      return choices.find((option) => option.value === value);
    } else {
      return null;
    }
  };

  return (
    <div className={`aea-form-dropdown-wrapper ${wrapperClassName || ''}`}>
      {label && <label className="aea-form-dropdown-label">{label}</label>}
      <Select
        placeholder={placeholder}
        options={choices}
        onChange={handleChange}
        value={getValue()}
        isSearchable={false}
        className={className}
        blurInputOnSelect={false}
        classNamePrefix="aea-form-component"
      />
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};

export default FormikDropdown;
